<template>
  <dashboard
    :charts="charts"
    :filters="filters"
    :results="search"
    :savedQueries="savedQueries"
    :mode="mode"
    :loadingSavedQueries="this.$apollo.queries.savedQueries.loading"
    :loadingCharts="this.$apollo.queries.charts.loading"
    :loadingFilters="this.$apollo.queries.filters.loading"
    :loadingPlugins="this.$apollo.queries.plugins.loading"
    :searching="this.$apollo.queries.search.loading"
    @download="handleDownload"
    @filter="handleFilter"
    @display-profiles="handleDisplayProfiles"
    @load-more-profiles="handleLoadMoreProfiles"
    @save-query="handleSaveQuery"
    @delete-query="handleDeleteQuery"
  />
</template>

<script>
import Dashboard from '@/components/profiles/Dashboard';
import chartsQuery from '@/graphql/profiles/pro/chartsQuery.gql';
import filtersQuery from '@/graphql/profiles/pro/filtersQuery.gql';
import searchQuery from '@/graphql/profiles/pro/searchQuery.gql';
import pluginsQuery from '@/graphql/profiles/pro/pluginsQuery.gql';
import savedQueries from '@/graphql/profiles/pro/savedQueries.gql';
import createSamplesetMutation from '@/graphql/profiles/pro/createSampleset.gql';
import saveQueryMutation from '@/graphql/profiles/pro/saveQueryMutation.gql';
import deleteQueryMutation from '@/graphql/profiles/pro/deleteQueryMutation.gql';

export default {
  name: 'ProfilesDashboardContainer',
  components: {
    Dashboard,
  },
  apollo: {
    plugins: {
      client: 'apiv2',
      query: pluginsQuery,
    },
    charts: {
      client: 'apiv2',
      prefetch: true,
      query: chartsQuery,
      result({ data }) {
        if (data && data.charts) {
          this.charts = {
            crossPlatformEngagement: data.charts.crossPlatformEngagement || {},
            audienceProfile: this.normalizeAudienceProfile(data.charts.audience),
          };
        }
      },
    },
    filters: {
      client: 'apiv2',
      query: filtersQuery,
    },
    savedQueries: {
      client: 'apiv2',
      query: savedQueries,
    },
    search: {
      client: 'apiv2',
      query: searchQuery,
      debounce: 200,
      variables: {
        query: JSON.stringify({
          'meta.opt_out': ['email', 'sms', 'whatsapp', 'telegram'],
        }),
        page: 0,
      },
    },
  },
  methods: {
    handleFilter(query) {
      this.$apollo.queries.search.refetch({ query: JSON.stringify(query) });
    },
    handleDisplayProfiles() {
      this.loadingProfiles = true;
    },
    handleLoadMoreProfiles() {
      this.page += 1;
      this.$apollo.queries.search.fetchMore({
        variables: {
          page: this.page,
        },
        updateQuery(previousResult, { fetchMoreResult }) {
          return {
            search: {
              ...previousResult.search,
              total: previousResult.search.total,
              filteredTotal: previousResult.search.filteredTotal,
              profiles: [...previousResult.search.profiles, ...fetchMoreResult.search.profiles],
            },
          };
        },
      });
    },
    handleDownload({ title: name, query, sampleSize }) {
      const filter = JSON.stringify(query);
      const exportType = sampleSize > 0 ? 'sample set' : 'contact list';
      this.$apollo
        .mutate({
          client: 'apiv2',
          mutation: createSamplesetMutation,
          variables: {
            name,
            filter,
            sampleSize,
          },
        })
        .then(() =>
          this.$notify({
            type: 'success',
            message: `You will receive a download link via email when your ${exportType} is ready for download.`,
          }),
        );
    },
    handleSaveQuery({ title, query }) {
      this.$apollo
        .mutate({
          client: 'apiv2',
          mutation: saveQueryMutation,
          variables: {
            title: title.value,
            filter: JSON.stringify(query),
            fields: [],
          },
        })
        .then(() => {
          this.$apollo.queries.savedQueries.refetch();

          this.$notify({
            type: 'success',
            message: 'Your query has been successfully saved.',
          });
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            message: 'Something went wrong while trying to save your query.',
          });
        });
    },
    handleDeleteQuery(id) {
      this.$apollo
        .mutate({
          client: 'apiv2',
          mutation: deleteQueryMutation,
          variables: {
            id,
          },
        })
        .then(() => {
          this.$apollo.queries.savedQueries.refetch();

          this.$notify({
            type: 'success',
            message: 'Your query has been successfully deleted.',
          });
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            message: 'Something went wrong while trying to deleted your saved query.',
          });
        });
    },
    normalizeAudienceProfile(audience) {
      if (!audience) return {};
      const result = {};
      Object.keys(audience).forEach(key => {
        result[key] = Array.isArray(audience[key]) ? audience[key] : [];
      });
      return result;
    },
  },
  computed: {
    mode() {
      const hasProPlugin = this.plugins.map(plugin => plugin.plugin).includes('profiles');
      return hasProPlugin ? 'pro' : 'lite';
    },
  },
  data: () => ({
    filters: {},
    lastQuery: {},
    page: 0,
    plugins: [],
    loadingProfiles: false,
    savedQueries: [],
    search: {
      total: 0,
      filteredTotal: 0,
      profiles: [],
    },
    charts: {
      crossPlatformEngagement: {},
      audienceProfile: {
        age: [],
        gender: [],
        ethnicity: [],
        location: [],
        language: [],
        numberOfChannels: [],
      },
    },
  }),
};
</script>

<style></style>



// WEBPACK FOOTER //
// ProfilesDashboardContainer.vue?703c0779